/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddBusinessOTPResponse
 */
export interface AddBusinessOTPResponse {
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOTPResponse
     */
    status: AddBusinessOTPResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOTPResponse
     */
    business_id: string;
}


/**
 * @export
 */
export const AddBusinessOTPResponseStatusEnum = {
    installing: 'installing',
    moved: 'moved',
    already_present: 'already_present'
} as const;
export type AddBusinessOTPResponseStatusEnum = typeof AddBusinessOTPResponseStatusEnum[keyof typeof AddBusinessOTPResponseStatusEnum];


/**
 * Check if a given object implements the AddBusinessOTPResponse interface.
 */
export function instanceOfAddBusinessOTPResponse(value: object): value is AddBusinessOTPResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('business_id' in value) || value['business_id'] === undefined) return false;
    return true;
}

export function AddBusinessOTPResponseFromJSON(json: any): AddBusinessOTPResponse {
    return AddBusinessOTPResponseFromJSONTyped(json, false);
}

export function AddBusinessOTPResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBusinessOTPResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'business_id': json['business_id'],
    };
}

export function AddBusinessOTPResponseToJSON(json: any): AddBusinessOTPResponse {
    return AddBusinessOTPResponseToJSONTyped(json, false);
}

export function AddBusinessOTPResponseToJSONTyped(value?: AddBusinessOTPResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'business_id': value['business_id'],
    };
}

